import { APIUrlConstants, AppConstants } from "../../../common/APIConstants";
import RestEndPoint from "../../../common/RestEndPoint";

export default class GainLossTransactionAPI {
  static getPMCTransactionScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetGainLossPMCTransactionData,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static getPAATransactionScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetGainLossPAATransactionData,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static updatePMCTransactionScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.UpdateGainLossPMCTransactionData,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static updatePAATransactionScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.UpdateGainLossPAATransactionData,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static getEntityList(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetEntityList,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static getProductionMonths() {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetProductionMonths,
      "GET",
      AppConstants.APP_BACKEND_HOST_KEY
    );
  }
  static getTransactionAuditData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetTransactionAuditData,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static FetchEABS(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.FetchEABS,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static FetchFBS(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.FetchFBS,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static FetchVMAC(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.FetchVMAC,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static FetchFlowCal(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.FetchFlowCal,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static FetchHW(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.FetchHW,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
}
